module.exports = __webpack_public_path__ + "static/media/logoExactoSignage.74471b19.png";